<template>
  <div>
    <div v-if="!hasPermission" class="workMaterial">
      <van-tabbar
        v-model="tabbarActive"
        active-color="#333"
        inactive-color="#999"
        safe-area-inset-bottom
      >
        <van-tabbar-item name="basic">
          <span>知识库</span>
          <template #icon="props">
            <img
              v-if="props.active"
              src="@/assets/img/material/icon_basic1.png"
              alt=""
            />
            <img v-else src="@/assets/img/material/icon_basic0.png" alt="" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item v-if="channel === 1" name="message">
          <span>话术库</span>
          <template #icon="props">
            <img
              v-if="props.active"
              src="@/assets/img/material/icon_message1.png"
              alt=""
            />
            <img v-else src="@/assets/img/material/icon_message0.png" alt="" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
      <!-- 基础素材 -->
      <div v-if="tabbarActive === 'basic'" class="basic-materials">
        <!-- 面包屑 -->
        <div v-if="!searchValue" class="crumbs">
          <div class="crumbs-box">
            <div
              v-for="(item, index) in crumbsList"
              :key="item.groupId"
              class="crumbs-list"
            >
              <img
                v-if="index > 0"
                class="xgang"
                src="@/assets/img/material/icon_xgang.png"
                alt=""
              />
              <span class="crumbs-item" @click="checkCrumbs(item, index)">{{
                item.groupName
              }}</span>
            </div>
          </div>
          <div
            v-if="showUpdateBtn && !isShare"
            class="update"
            @click="updateFn"
          >
            更新订阅
          </div>
        </div>
        <div v-else class="crumbs">
          <div class="crumbs-box">
            <div
              v-for="(item, index) in crumbsList"
              :key="item.groupId"
              class="crumbs-list"
            >
              <img
                v-if="index > 0"
                class="xgang"
                src="@/assets/img/material/icon_xgang.png"
                alt=""
              />
              <span class="crumbs-item" @click="checkCrumbs(item, index)">{{
                item.groupName
              }}</span>
            </div>
          </div>
          <div v-if="!isShare" class="update" @click="updateFn">
            更新订阅
          </div>
        </div>
        <!-- 搜索框 -->
        <div v-if="!isShare" class="search-box">
          <div class="left">
            <van-search
              v-model="searchValue"
              placeholder="请输入素材标签或素材名称"
              :clearable="false"
              disabled
            >
              <template #left-icon>
                <img src="@/assets/img/material/icon_select.png" alt="" />
              </template>
            </van-search>
            <div class="search-region" @click="goSearchPage"></div>
          </div>
          <img
            v-if="!showOverlay"
            style="width: 20px; height: 20px; cursor: pointer;"
            src="@/assets/img/material/icon_filter.png"
            alt=""
            @click="showOverlay = !showOverlay"
          />
          <img
            v-else
            style="width: 20px; height: 20px; cursor: pointer;"
            src="@/assets/img/material/icon_filter1.png"
            alt=""
            @click="showOverlay = !showOverlay"
          />
        </div>
        <div v-if="showOverlay" class="popup-tags">
          <van-tabs
            v-model="tabActive"
            :lazy-render="false"
            sticky
            color="#333333"
            line-width="32"
            line-height="2"
          >
            <van-tab
              :title="
                tagIdList.length > 0 ? `标签(${tagIdList.length})` : '标签'
              "
            >
              <div
                v-for="item in tagList"
                :key="item.tagGroupId"
                class="tag-item"
              >
                <div v-if="item.tagList.length > 0" class="tag-cont">
                  <div class="tags-title">
                    {{ item.tagGroupName }}
                  </div>
                  <div class="tags-list">
                    <div
                      v-for="x in item.tagList"
                      :key="x.tagId"
                      class="tags-item"
                      :class="tagIdList.includes(x.tagId) ? 'act' : ''"
                      @click="checkTag(x)"
                    >
                      {{ x.tagName }}
                    </div>
                  </div>
                </div>
              </div>
            </van-tab>
          </van-tabs>
          <div class="reset" @click="resetTags">重置</div>
        </div>
        <van-overlay :show="showOverlay" @click="showOverlay = false" />
        <!-- 内容 -->
        <div
          v-if="groupList.length > 0 || fileList.length > 0"
          class="cont"
          :class="isShare ? 'isShare' : ''"
        >
          <div
            v-if="groupList.length > 0 && !searchValue && showGroup"
            class="list-box"
          >
            <div class="list-title">素材分组</div>
            <div
              v-for="item in groupList"
              :key="item.groupId"
              class="folder"
              @click.once="enterFolder(item)"
            >
              <div class="folder-left">
                <img
                  v-if="item.groupId !== -99"
                  class="folder-img"
                  src="@/assets/img/material/icon_folder.png"
                  alt=""
                />
                <img
                  v-if="item.groupId === -99"
                  class="folder-img"
                  src="@/assets/img/material/icon_share.png"
                  alt=""
                />
                <span>{{ item.groupName }}</span>
              </div>
              <img
                v-if="!isShare"
                class="more-img"
                src="@/assets/img/material/icon_more.png"
                alt=""
                @click.stop="openSharePopup(1, item)"
              />
            </div>
          </div>
          <div v-if="fileList.length > 0" class="list-box">
            <div class="list-title">
              <div>素材文件</div>
              <div
                class="sort"
                :class="sort ? 'forwardCount' : ''"
                @click="checkSort"
              >
                <img
                  class="icon-sort"
                  src="@/assets/img/material/icon_sort.png"
                  alt=""
                />
                <div>按转发量</div>
              </div>
            </div>
            <van-list
              v-model="loading"
              class="task-list"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <div
                v-for="item in fileList"
                :key="item.id"
                class="files"
                @click="preview(item)"
              >
                <div class="file-left">
                  <img
                    v-if="item.type === 1"
                    class="file-img"
                    :src="item.cosPath + '&imageMogr2/crop/40x40'"
                    alt=""
                  />
                  <img
                    v-if="item.type === 2"
                    class="file-img"
                    :src="item.videoCoverUrl + '&imageMogr2/crop/40x40'"
                    alt=""
                  />
                  <img
                    v-if="item.type === 3"
                    class="file-img"
                    :src="item.imgUrl + '&imageMogr2/crop/40x40'"
                    alt=""
                  />
                  <template>
                    <img
                      v-if="
                        item.type === 4 &&
                          (item.attachment.ext === 'png' ||
                            item.attachment.ext === 'jpg')
                      "
                      class="file-img"
                      src="@/assets/img/material/icon_img.png"
                      alt=""
                    />
                    <img
                      v-else-if="
                        item.type === 4 && item.attachment.ext === 'mp4'
                      "
                      class="file-img"
                      src="@/assets/img/material/icon_video.png"
                      alt=""
                    />
                    <img
                      v-else-if="
                        item.type === 4 &&
                          (item.attachment.ext === 'xlsx' ||
                            item.attachment.ext === 'xls')
                      "
                      class="file-img"
                      src="@/assets/img/material/icon_excel.png"
                      alt=""
                    />
                    <img
                      v-else-if="
                        item.type === 4 &&
                          (item.attachment.ext === 'docx' ||
                            item.attachment.ext === 'doc')
                      "
                      class="file-img"
                      src="@/assets/img/material/icon_word.png"
                      alt=""
                    />
                    <img
                      v-else-if="
                        item.type === 4 && item.attachment.ext === 'zip'
                      "
                      class="file-img"
                      src="@/assets/img/material/icon_zip.png"
                      alt=""
                    />
                    <img
                      v-else-if="
                        item.type === 4 &&
                          (item.attachment.ext === 'ppt' ||
                            item.attachment.ext === 'pptx')
                      "
                      class="file-img"
                      src="@/assets/img/material/icon_ppt.png"
                      alt=""
                    />
                    <img
                      v-else-if="
                        item.type === 4 && item.attachment.ext === 'pdf'
                      "
                      class="file-img"
                      src="@/assets/img/material/icon_pdf.png"
                      alt=""
                    />
                    <img
                      v-else-if="
                        item.type === 4 &&
                          (item.attachment.ext === 'mp3' ||
                            item.attachment.ext === 'amr' ||
                            item.attachment.ext === 'wav')
                      "
                      class="file-img"
                      src="@/assets/img/material/icon_mp3.png"
                      alt=""
                    />
                    <img
                      v-else-if="
                        item.type === 4 && item.attachment.ext === 'txt'
                      "
                      class="file-img"
                      src="@/assets/img/material/icon_txt.png"
                      alt=""
                    />
                    <img
                      v-else-if="
                        item.type === 4 && item.attachment.ext === 'psd'
                      "
                      class="file-img"
                      src="@/assets/img/material/icon_psd.png"
                      alt=""
                    />
                  </template>
                  <div class="file-info">
                    <div class="file-i-title">
                      {{ item.title }}
                    </div>
                    <div v-if="item.type === 1" class="file-i-time">
                      {{ formatTime(item.createTime) }}
                      转发量{{ item.forwardCount }}
                    </div>
                    <div v-if="item.type === 2" class="file-i-time">
                      {{ formatTime(item.createTime) }}
                      转发量{{ item.forwardCount }}
                    </div>
                    <div v-if="item.type === 3" class="file-i-time">
                      {{ formatTime(item.createTime) }} 转发量{{
                        item.forwardCount
                      }}
                    </div>
                    <div v-if="item.type === 4" class="file-i-time">
                      {{ formatTime(item.createTime) }}
                      转发量{{ item.forwardCount }}
                    </div>
                  </div>
                </div>
                <img
                  v-if="
                    !isMobile &&
                      item.isDownload &&
                      (item.type === 1 ||
                        item.type === 2 ||
                        (item.type === 4 && item.attachment.ext !== 'pdf') ||
                        (item.attachment.ext === 'pdf' &&
                          item.isWatermark === 0))
                  "
                  class="download-img"
                  src="@/assets/img/material/icon_download.png"
                  alt=""
                  @click.stop="downloadFn(item)"
                />
                <img
                  v-if="
                    !isMobile &&
                      item.isDownload &&
                      item.type === 4 &&
                      item.attachment.ext === 'pdf' &&
                      item.isWatermark === 1
                  "
                  class="download-img"
                  src="@/assets/img/material/icon_download.png"
                  alt=""
                  @click.stop="previewDownload(item)"
                />
                <img
                  class="more-img"
                  src="@/assets/img/material/icon_more.png"
                  alt=""
                  @click.stop="openSharePopup(2, item)"
                />
                <img
                  v-if="item.isHead === 1"
                  class="zb"
                  src="@/assets/img/material/icon_zb.png"
                  alt=""
                />
              </div>
            </van-list>
          </div>
        </div>
        <div v-else class="no-more">没有更多了</div>
      </div>
      <!-- 话术库 -->
      <div v-if="tabbarActive === 'message' && channel === 1">
        <SpeechBank :is-workbenches="true"></SpeechBank>
      </div>
      <!-- 更多面板 -->
      <van-popup
        v-model="show"
        class="more-popup"
        closeable
        position="bottom"
        round
        :style="{ height: '30%' }"
        safe-area-inset-bottom
      >
        <div class="more-title">
          <img
            v-if="popupType === 1"
            class="folder-img"
            src="@/assets/img/material/icon_folder.png"
            alt=""
          />
          <img v-if="popupType === 2" :src="filePopupCover" alt="" />
          <div>
            <div v-if="popupType === 1" class="txt1">{{ materialName }}</div>
            <div v-if="popupType === 1" class="txt2">{{ founder }}</div>
            <div v-if="popupType === 2" class="txt1">{{ materialName }}</div>
            <div v-if="popupType === 2" class="txt2">创建人：{{ founder }}</div>
            <div
              v-if="popupType === 2 && isForward === 1 && channel === 1"
              class="txt3"
            >
              微信客户每天只能收到一次转发
            </div>
          </div>
        </div>
        <div class="more-list">
          <div
            v-if="popupType === 2 && isForward === 1 && channel === 1"
            class="popup-item"
            @click="forwardToCustomer"
          >
            <img src="@/assets/img/material/icon_forward1.png" alt="" />
            <div>转发给客户</div>
          </div>
          <div
            v-if="channel === 1"
            class="popup-item"
            @click="forwardToColleagues"
          >
            <img src="@/assets/img/material/icon_forward2.png" alt="" />
            <div>转发给同事</div>
          </div>
          <div
            v-if="
              popupType === 1 ||
                (popupType === 2 && isForward === 1 && channel === 1)
            "
            class="popup-item"
            @click="copyLink"
          >
            <img src="@/assets/img/material/icon_forward3.png" alt="" />
            <div>复制链接</div>
          </div>
          <div
            v-if="
              popupType === 2 &&
                !isMobile &&
                fileInfo.isDownload &&
                (fileInfo.type === 1 ||
                  fileInfo.type === 2 ||
                  (fileInfo.type === 4 && fileInfo.attachment.ext !== 'pdf') ||
                  (fileInfo.attachment.ext === 'pdf' &&
                    fileInfo.isWatermark === 0))
            "
            class="popup-item"
            @click="downloadFn(null)"
          >
            <img src="@/assets/img/material/icon_download2.png" alt="" />
            <div>下载</div>
          </div>
          <div
            v-if="
              popupType === 2 &&
                !isMobile &&
                fileInfo.isDownload &&
                fileInfo.type === 4 &&
                fileInfo.attachment.ext === 'pdf' &&
                fileInfo.isWatermark === 1
            "
            class="popup-item"
            @click="previewDownload(null)"
          >
            <img src="@/assets/img/material/icon_download2.png" alt="" />
            <div>下载</div>
          </div>
        </div>
      </van-popup>
      <!-- 预览视频 -->
      <van-popup v-model="showPreviewVideo" class="video-popup">
        <video
          ref="videoRef"
          class="video"
          src=""
          controls
          :autoplay="false"
          playsinline
          webkit-playsinline
          x5-video-player-type="h5"
          x5-video-player-fullscreen="true"
        ></video>
      </van-popup>
      <!-- 预览音频 -->
      <van-popup v-model="showPreviewAudio" class="audio-popup">
        <audio ref="audioRef" src="" controls></audio>
      </van-popup>
      <!-- 预览图文 -->
      <van-popup
        v-model="showPreviewImgTxt"
        class="imgtxt-popup"
        closeable
        position="bottom"
        round
        :style="{ height: '90%' }"
        safe-area-inset-bottom
      >
        <div class="popup-main">
          <div class="imgtxt-title">
            {{ fileInfo.title }}
          </div>
          <div class="imgtxt-cont" v-html="fileInfo.content"></div>
        </div>
      </van-popup>
    </div>
    <!-- 无权限 -->
    <div v-else class="permission">
      <img class="error" src="@/assets/img/material/icon_error.png" alt="" />
      <div class="txt">{{ txt }}</div>
    </div>
    <!-- 水印 -->
    <vue-watermark
      v-if="showWatermark"
      :key="watermarkKey"
      :text="watermarkText"
      :font-size="16"
      :line-height="24"
      :width="100"
      :height="60"
      :angle="-15"
      :opacity="0.1"
    />
    <!-- 图片质量动作面板 -->
    <van-action-sheet
      v-model="showActionSheet"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      @select="selectSheet"
    />
    <!-- 预览图片 -->
    <div
      v-if="showPreviewImgOverlay"
      class="img-overlay"
      @click="closeImgOverlay"
    ></div>
  </div>
</template>

<script>
import SpeechBank from "@/views/speechbank/index.vue";
import {
  getMaterialApi,
  currGroupListApi,
  uploadMediaApi,
  addDownloadRecordApi,
  getCosKeyApi,
  shareCurrGroupListApi,
  shareGetMaterialApi,
} from "@/api/modules/material";
import { tagGroupListApi } from "@/api/modules/speechbank";
import dayjs from "dayjs";
import { Toast, ImagePreview } from "vant";
import wxSDK from "@/scripts/wxsdk";
import { isMobileClient, browseEvent, pageClickEvent } from "@/utils/utils";
import { cosObj } from "@/utils/index";
import icon_excel from "@/assets/img/material/icon_excel.png";
import icon_mp3 from "@/assets/img/material/icon_mp3.png";
import icon_pdf from "@/assets/img/material/icon_pdf.png";
import icon_txt from "@/assets/img/material/icon_txt.png";
import icon_word from "@/assets/img/material/icon_word.png";
import icon_video from "@/assets/img/material/icon_video.png";
import icon_img from "@/assets/img/material/icon_img.png";
import icon_ppt from "@/assets/img/material/icon_ppt.png";
import icon_zip from "@/assets/img/material/icon_zip.png";
import icon_lj from "@/assets/img/material/icon_lj.png";
import icon_psd from "@/assets/img/material/icon_psd.png";
import { getWechatEnv, getFilesize } from "@/utils/utils";
import VueWatermark from "vue-watermark";
import { encodeURI } from "js-base64";

export default {
  name: "WorkMaterial",
  components: {
    VueWatermark,
    SpeechBank,
  },
  data() {
    return {
      channel: getWechatEnv(), // 企微1 微信2
      isMobile: isMobileClient(),
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      cosKey: {}, // cos相关key
      crumbsList: [
        {
          groupName: "基础素材库",
          groupId: 0,
        },
      ], // 面包屑列表
      tabbarActive: "basic", // tabbar
      searchValue: "", // 素材搜索内容
      show: false,
      popupType: 0,
      groupId: 0, // 分组id
      fileList: [], // 素材文件列表
      loading: false,
      finished: false,
      pageIndex: 1,
      pageSize: 20,
      materialName: "", // 文件夹名称、素材名称
      founder: "", // 创建人
      groupList: [], // 文件夹列表
      showPreviewImgOverlay: false, // 预览图片
      previewImgRef: null,
      showPreviewVideo: false, // 预览视频
      showPreviewAudio: false, // 预览音频
      showPreviewImgTxt: false, // 预览图文
      fileInfo: "", // 文件信息
      filePopupCover: "", // 分享面板封面
      sort: "", // 素材排序字段
      crumbsIds: "",
      isForward: 0, // 0不可转发 1可转发
      // 定义文件类型图标映射
      iconMap: {
        png:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_img.png",
        jpg:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_img.png",
        mp4:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_video.png",
        xlsx:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_excel.png",
        xls:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_excel.png",
        docx:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_word.png",
        doc:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_word.png",
        zip:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_zip.png",
        ppt:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_ppt.png",
        pptx:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_ppt.png",
        pdf:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_pdf.png",
        mp3:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_mp3.png",
        amr:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_mp3.png",
        txt:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_txt.png",
        psd:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_psd.png",
        lj:
          "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_lj.png",
      },
      hasPermission: false, // 是否有权限访问
      txt: "", // 无权限提示词
      watermarkText: "", // 水印
      showWatermark: true,
      showOverlay: false, // 遮层
      tagList: [], // 素材标签列表
      tagIdList: [], // 素材标签id列表
      showActionSheet: false, // 图片质量动作面板
      actions: [
        { name: "OOH/高精度图片", subname: "该类型图片主要用于户外大牌" },
        { name: "OOH/中精度图片", subname: "该类型图片主要用于梯媒或杂志" },
        { name: "Digital图片", subname: "该类型图片主要用于数字化Banner" },
      ],
      imgQuality: "", // 图片质量拼参
      toast: null,
      key: "", // 存储在桶里的对象键
      fileName: "", // 文件名
      showUpdateBtn: true, // 展示更新订阅按钮
      isShare: false, // 分享进入的页面flag
      showGroup: true, // 是否展示分组
      tabActive: 0, // 0标签
      watermarkKey: 0, // 水印组件的key，用于强制重建
      startTime: dayjs(), // 开始时间
      page_url: window.location.href, // 页面链接
      page_id: window.location.pathname, // 页面唯一标识
    };
  },
  watch: {
    async $route(to, from) {
      if (to.query.ids && from.name !== "createAndEdit") {
        const ids = to.query.ids.split(",").map(Number);
        const filteredGroups = this.crumbsList.filter((item) =>
          ids.includes(item.groupId)
        );
        this.crumbsList = filteredGroups;
        this.fileList = [];
        this.pageIndex = 1;
        this.finished = false;
        this.getFolder();
        this.searchValue = sessionStorage.getItem("searchValue");
        const shareKey = sessionStorage.getItem("shareKey");
        const isGroupShare = sessionStorage.getItem("isGroupShare");
        if (
          (ids.length === 1 &&
            (this.searchValue || shareKey || isGroupShare)) ||
          ids.length > 1
        ) {
          this.getMaterial();
        }
        if (!shareKey) {
          this.getTagGroupList();
          await wxSDK.config(
            [
              "shareToExternalContact",
              "shareAppMessage",
              "previewFile",
              "shareWechatMessage",
            ],
            [
              "shareToExternalContact",
              "shareAppMessage",
              "previewFile",
              "shareWechatMessage",
            ]
          );
        }
      }
      if (from.path === "/s/file") {
        // 埋点 分组 浏览开始
        browseEvent({
          tab_name: "素材", // tab名称
          page_name: "素材分组", // 页面名
          page_url: this.page_url, // 页面链接
          page_id: this.page_id, // 页面唯一标识
          folder_id: this.crumbsList[this.crumbsList.length - 1].groupId, // 文件夹id
          folder_name: this.crumbsList[this.crumbsList.length - 1].groupName, // 文件夹名称
          start_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 开始时间
        });
        this.showWatermark = true;
        sessionStorage.removeItem("watermarkText");
      }
      if (from.name === "message" || from.name === "searchMaterial") {
        if (this.crumbsList.length === 1) {
          // 埋点 浏览开始
          browseEvent({
            tab_name: "素材", // tab名称
            page_name: "素材首页", // 页面名
            page_url: this.page_url, // 页面链接
            page_id: this.page_id, // 页面唯一标识
            start_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 开始时间
          });
        }
        if (this.crumbsList.length > 1) {
          // 埋点 分组 浏览开始
          browseEvent({
            tab_name: "素材", // tab名称
            page_name: "素材分组", // 页面名
            page_url: this.page_url, // 页面链接
            page_id: this.page_id, // 页面唯一标识
            folder_id: this.crumbsList[this.crumbsList.length - 1].groupId, // 文件夹id
            folder_name: this.crumbsList[this.crumbsList.length - 1].groupName, // 文件夹名称
            start_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 开始时间
          });
        }
      }
    },
    // 监听tabbarActive变化，控制水印
    tabbarActive(newVal) {
      if (newVal === "message") {
        // 切换到话术库：手动清理残留的水印DOM
        setTimeout(() => {
          const watermarkEls = document.querySelectorAll(".watermark");
          watermarkEls[0].remove();
        }, 0);
      }
    },
  },
  async created() {
    if (this.$route.query.shareKey) {
      // 分享页面
      this.isShare = true;
      sessionStorage.setItem("shareKey", this.$route.query.shareKey);
      this.getFolder();
      this.getMaterial();
    } else if (this.$route.query.isGroupShare) {
      // 分享同事 分组
      this.isShare = true;
      sessionStorage.setItem("isGroupShare", 1);
      this.crumbsList[0].groupId = Number(this.$route.query.ids);
      this.crumbsList[0].groupName = this.$route.query.groupName;
      this.getFolder();
      this.getMaterial();
    } else {
      // 正常进入
      await this.handleIdsParam();
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      if (userInfo) {
        this.watermarkText = `${this.userInfo.name}${this.userInfo.userId.slice(
          -4
        )}`;
        const shareKey = sessionStorage.getItem("shareKey");
        if (!shareKey) {
          if (!this.isMobile) {
            this.getCiKey();
          }
          await wxSDK.config(
            [
              "shareToExternalContact",
              "shareAppMessage",
              "previewFile",
              "shareWechatMessage",
            ],
            [
              "shareToExternalContact",
              "shareAppMessage",
              "previewFile",
              "shareWechatMessage",
            ]
          );
        }
        this.getFolder();
        const ids = this.$route.query.ids.split(",").map(Number);
        if (ids.length > 1) {
          this.getMaterial();
        }
        this.getTagGroupList();
      }
    }
  },
  mounted() {
    // 埋点 浏览开始
    browseEvent({
      tab_name: "素材", // tab名称
      page_name: "素材首页", // 页面名
      page_url: this.page_url, // 页面链接
      page_id: this.page_id, // 页面唯一标识
      start_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 开始时间
    });
  },
  beforeRouteLeave(to, from, next) {
    if (this.crumbsList.length === 1) {
      // 埋点 浏览结束
      browseEvent({
        tab_name: "素材", // tab名称
        page_name: "素材首页", // 页面名
        page_url: this.page_url, // 页面链接
        page_id: this.page_id, // 页面唯一标识
        end_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 结束时间
        view_time: dayjs().diff(this.startTime, "second"), // 页面停留时长
      });
    }
    if (this.crumbsList.length > 1) {
      // 埋点 分组 浏览结束
      browseEvent({
        tab_name: "素材", // tab名称
        page_name: "素材分组", // 页面名
        page_url: this.page_url, // 页面链接
        page_id: this.page_id, // 页面唯一标识
        folder_id: this.crumbsList[this.crumbsList.length - 1].groupId, // 文件夹id
        folder_name: this.crumbsList[this.crumbsList.length - 1].groupName, // 文件夹名称
        end_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 结束时间
        view_time: dayjs().diff(this.startTime, "second"), // 页面停留时长
      });
    }
    next();
  },
  methods: {
    // 处理刷新 参数问题
    handleIdsParam() {
      const { search } = window.location;
      if (!search) return;

      const params = new URLSearchParams(search);
      const ids = params.get("ids");

      if (ids && ids !== "0" && ids.startsWith("0,")) {
        params.set("ids", "0");
        const newQuery = {};
        params.forEach((value, key) => {
          newQuery[key] = value;
        });
        this.$router.replace({
          ...this.$route,
          query: newQuery,
        });
      }
    },
    // 格式化时间
    formatTime(finishTime) {
      return dayjs(finishTime).format("YYYY-MM-DD");
    },
    // 格式化文件大小
    formatFileSize(sizeInKB) {
      // 定义单位数组和对应的字节数
      const units = ["KB", "MB", "GB", "TB"];
      const thresholds = [1, 1024, 1024 * 1024, 1024 * 1024 * 1024];
      // 确定使用哪个单位
      let unitIndex = 0;
      while (
        sizeInKB >= thresholds[unitIndex + 1] &&
        unitIndex < units.length - 1
      ) {
        unitIndex++;
      }
      // 计算转换后的值并处理精度问题
      const size = sizeInKB / thresholds[unitIndex];
      const formattedSize = parseFloat(size.toFixed(2));
      // 返回格式化后的字符串
      return `${formattedSize} ${units[unitIndex]}`;
    },
    // 获取coskey
    async getCiKey() {
      const res = await getCosKeyApi();
      if (res.code === 0) {
        this.cosKey = res.data;
      }
    },
    // 切换面包屑导航
    checkCrumbs(value, index) {
      if (
        value.groupId === this.crumbsList[this.crumbsList.length - 1].groupId
      ) {
        return;
      } else {
        // 埋点 分组 浏览结束
        browseEvent({
          tab_name: "素材", // tab名称
          page_name: "素材分组", // 页面名
          page_url: this.page_url, // 页面链接
          page_id: this.page_id, // 页面唯一标识
          folder_id: this.crumbsList[this.crumbsList.length - 1].groupId, // 文件夹id
          folder_name: this.crumbsList[this.crumbsList.length - 1].groupName, // 文件夹名称
          end_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 结束时间
          view_time: dayjs().diff(this.startTime, "second"), // 页面停留时长
        });
        const ids = this.crumbsList
          .slice(0, index + 1)
          .map((item) => item.groupId)
          .join();
        this.$router.replace({
          name: "workMaterial",
          query: {
            ids,
          },
        });
        if (ids === "0") {
          // 埋点 浏览开始
          browseEvent({
            tab_name: "素材", // tab名称
            page_name: "素材首页", // 页面名
            page_url: this.page_url, // 页面链接
            page_id: this.page_id, // 页面唯一标识
            start_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 开始时间
          });
        }
        this.showOverlay = false;
      }
    },
    // 进入搜索页面
    goSearchPage() {
      const shareKey = sessionStorage.getItem("shareKey");
      if (shareKey) {
        this.$router.push(`/searchMaterial?shareKey=${shareKey}`);
      } else {
        this.$router.push("/searchMaterial");
      }
    },
    // 获取文件夹
    async getFolder() {
      // 显示隐藏“更新订阅”按钮
      if (this.$route.query.ids) {
        if (this.$route.query.ids.split(",").length > 1) {
          this.showUpdateBtn = false;
        } else {
          this.showUpdateBtn = true;
        }
      }

      const shareKey = sessionStorage.getItem("shareKey");
      let res;
      if (shareKey) {
        // 未登录
        res = await shareCurrGroupListApi({
          parentId: this.crumbsList[this.crumbsList.length - 1].groupId,
          key: shareKey ? shareKey.replaceAll(" ", "+") : "",
        });
      } else {
        // 已登录
        res = await currGroupListApi({
          parentId: this.crumbsList[this.crumbsList.length - 1].groupId,
        });
      }

      if (res.code === 0) {
        this.groupList = res.data;
      } else {
        // 无权限访问
        this.hasPermission = true;
        this.txt = "无访问权限，请联系管理员";
      }
    },
    // 获取素材
    async getMaterial() {
      Toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true,
      });

      const shareKey = sessionStorage.getItem("shareKey");
      const groupId = this.crumbsList[this.crumbsList.length - 1].groupId;
      let res;
      if (shareKey) {
        // 未登录
        res = await shareGetMaterialApi({
          groupId: groupId,
          likeName: this.searchValue,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          sort: this.sort,
          key: shareKey ? shareKey.replaceAll(" ", "+") : "",
          tags: this.tagIdList,
        });
      } else {
        // 已登录
        res = await getMaterialApi({
          groupId: groupId,
          likeName: this.searchValue,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          sort: this.sort,
          tags: this.tagIdList,
        });
      }

      if (res.code === 0) {
        const list = res.data.dataList.map((item) => {
          if (item.type === 1) {
            return {
              ...item,
              pictures: JSON.parse(item.pictures[0]),
            };
          } else if (item.type === 2) {
            return {
              ...item,
              videos: JSON.parse(item.videos[0]),
            };
          } else if (item.type === 3) {
            return item;
          } else if (item.type === 4) {
            return {
              ...item,
              attachment: JSON.parse(item.attachment[0]),
            };
          }
        });
        this.fileList = this.fileList.concat(list);
        Toast.clear();
        this.loading = false;
        if (res.data.dataList.length < 10) {
          this.finished = true;
        }
      } else {
        Toast.clear();
        // 无权限访问
        this.hasPermission = true;
        this.txt = "无访问权限，请联系管理员";
      }
    },
    // 加载list
    onLoad() {
      this.pageIndex++;
      this.getMaterial();
    },
    // 打开分享面板
    openSharePopup(type, item) {
      console.log(item);
      if (type === 1) {
        this.materialName = item.groupName;
        this.founder = dayjs().format("YYYY-MM-DD");
      } else {
        this.materialName = item.title;
        if (item.type === 1) {
          // 图片
          this.filePopupCover = item.cosPath;
        } else if (item.type === 2) {
          // 视频
          this.filePopupCover = item.videoCoverUrl;
        } else if (item.type === 3) {
          this.filePopupCover = item.imgUrl;
        } else if (item.type === 4) {
          if (item.attachment.ext === "png" || item.attachment.ext === "jpg") {
            this.filePopupCover = icon_img;
          } else if (item.attachment.ext === "mp4") {
            this.filePopupCover = icon_video;
          } else if (
            item.attachment.ext === "xlsx" ||
            item.attachment.ext === "xls"
          ) {
            this.filePopupCover = icon_excel;
          } else if (
            item.attachment.ext === "docx" ||
            item.attachment.ext === "doc"
          ) {
            this.filePopupCover = icon_word;
          } else if (
            item.attachment.ext === "ppt" ||
            item.attachment.ext === "pptx"
          ) {
            this.filePopupCover = icon_ppt;
          } else if (item.attachment.ext === "pdf") {
            this.filePopupCover = icon_pdf;
          } else if (
            item.attachment.ext === "mp3" ||
            item.attachment.ext === "amr"
          ) {
            this.filePopupCover = icon_mp3;
          } else if (item.attachment.ext === "zip") {
            this.filePopupCover = icon_zip;
          } else if (item.attachment.ext === "txt") {
            this.filePopupCover = icon_txt;
          } else if (item.attachment.ext === "psd") {
            this.filePopupCover = icon_psd;
          } else {
            this.filePopupCover = icon_lj;
          }
        }
        this.founder = item.creatorName;
        this.isForward = item.isForward;
      }
      this.fileInfo = item;
      this.popupType = type;
      this.show = true;
    },
    // 进入文件夹
    enterFolder(item) {
      if (this.crumbsList.length === 1) {
        // 埋点 浏览结束
        browseEvent({
          tab_name: "素材", // tab名称
          page_name: "素材首页", // 页面名
          page_url: this.page_url, // 页面链接
          page_id: this.page_id, // 页面唯一标识
          end_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 结束时间
          view_time: dayjs().diff(this.startTime, "second"), // 页面停留时长
        });
      }
      if (this.crumbsList.length > 1) {
        // 埋点 分组 浏览结束
        browseEvent({
          tab_name: "素材", // tab名称
          page_name: "素材分组", // 页面名
          page_url: this.page_url, // 页面链接
          page_id: this.page_id, // 页面唯一标识
          folder_id: this.crumbsList[this.crumbsList.length - 1].groupId, // 文件夹id
          folder_name: this.crumbsList[this.crumbsList.length - 1].groupName, // 文件夹名称
          end_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 结束时间
          view_time: dayjs().diff(this.startTime, "second"), // 页面停留时长
        });
      }
      this.crumbsList.push({
        groupName: item.groupName,
        groupId: item.groupId,
      });
      const ids = this.crumbsList.map((item) => item.groupId);
      console.log(ids);

      this.fileList = [];
      this.pageIndex = 1;
      this.$router.push({
        name: "workMaterial",
        query: {
          ids: ids.join(),
        },
      });
      // 埋点 分组 浏览开始
      browseEvent({
        tab_name: "素材", // tab名称
        page_name: "素材分组", // 页面名
        page_url: this.page_url, // 页面链接
        page_id: this.page_id, // 页面唯一标识
        folder_id: item.groupId, // 文件夹id
        folder_name: item.groupName, // 文件夹名称
        start_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 开始时间
      });
    },
    // 预览图片、视频、图文、文件
    async preview(item) {
      console.log(item);
      if (item.type === 1) {
        item.size = item.pictures.size;
        item.ext = item.pictures.ext;
        // 图片
        if (this.isMobile) {
          // 移动端
          if (item.isForward === 1 && item.isDownload) {
            const size = await getFilesize(item.cosPath);
            // 可分享客户和可下载
            await wxSDK.previewFile({
              url: item.cosPath.replace("https:", "http:"),
              name: item.pictures.name,
              size,
            });
          } else {
            // 不可分享和下载
            this.showPreviewImgOverlay = true;
            this.previewImgRef = ImagePreview({
              images: [item.cosPath],
              showIndex: false,
              asyncClose: true,
            });
          }
        } else {
          // pc端
          ImagePreview({
            images: [item.cosPath],
            showIndex: false,
          });
        }
      } else if (item.type === 2) {
        item.size = item.videos.size;
        item.ext = item.videos.ext;
        // 视频
        if (this.isMobile) {
          // 移动端
          if (item.isForward === 1 && item.isDownload) {
            const size = await getFilesize(item.cosPath);
            // 可分享客户和可下载
            await wxSDK.previewFile({
              url: item.cosPath.replace("https:", "http:"),
              name: item.videos.name,
              size,
            });
          } else {
            // 不可分享和下载
            window.open(item.cosPath);
          }
        } else {
          // pc端
          this.showPreviewVideo = true;
          setTimeout(() => {
            this.$refs.videoRef.src = item.cosPath;
          }, 500);
        }
      } else if (item.type === 3) {
        item.size = "";
        item.ext = "";
        // 图文
        this.fileInfo = item;
        this.showPreviewImgTxt = true;
      } else if (item.type === 4) {
        item.size = item.attachment.size;
        item.ext = item.attachment.ext;
        // 文件
        if (this.isMobile) {
          // 移动端
          if (item.attachment.ext === "pdf") {
            this.showWatermark = false;
            if (item.isWatermark === 1) {
              sessionStorage.setItem("watermarkText", this.watermarkText);
            }
            if (this.isShare) {
              // 分享页面进入素材
              this.$router.push(`/s/file?shareKey=${item.shareKey}`);
            } else {
              // 正常进入
              this.$router.push(`/s/file?id=${item.id}`);
            }
          } else if (
            item.attachment.ext === "png" ||
            item.attachment.ext === "jpg"
          ) {
            if (item.isForward === 1 && item.isDownload) {
              const size = await getFilesize(item.cosPath);
              // 可分享客户和可下载
              await wxSDK.previewFile({
                url: item.cosPath.replace("https:", "http:"),
                name: item.pictures.name,
                size,
              });
            } else {
              // 不可分享和下载
              this.showPreviewImgOverlay = true;
              this.previewImgRef = ImagePreview({
                images: [item.cosPath],
                showIndex: false,
                asyncClose: true,
              });
            }
          } else if (item.attachment.ext === "mp4") {
            if (item.isForward === 1 && item.isDownload) {
              const size = await getFilesize(item.cosPath);
              // 可分享客户和可下载
              await wxSDK.previewFile({
                url: item.cosPath.replace("https:", "http:"),
                name: item.videos.name,
                size,
              });
            } else {
              // 不可分享和下载
              window.open(item.cosPath);
            }
          } else {
            window.open(item.cosPath);
          }
        } else {
          // pc端
          if (item.attachment.ext === "mp4") {
            this.showPreviewVideo = true;
            setTimeout(() => {
              this.$refs.videoRef.src = item.cosPath;
            }, 500);
          } else if (
            item.attachment.ext === "mp3" ||
            item.attachment.ext === "amr"
          ) {
            this.showPreviewAudio = true;
            setTimeout(() => {
              this.$refs.audioRef.src = item.cosPath;
            }, 500);
          } else if (
            item.attachment.ext === "png" ||
            item.attachment.ext === "jpg"
          ) {
            ImagePreview({
              images: [item.cosPath],
              showIndex: false,
            });
          } else if (item.attachment.ext === "pdf") {
            this.showWatermark = false;
            if (item.isWatermark === 1) {
              // 有水印
              sessionStorage.setItem("watermarkText", this.watermarkText);
            }
            if (this.isShare) {
              // 分享页面进入素材
              this.$router.push(`/s/file?shareKey=${item.shareKey}`);
            } else {
              // 正常进入
              this.$router.push(`/s/file?id=${item.id}`);
            }
          }
        }
      }
      // 埋点 素材查看
      pageClickEvent({
        button_name: "素材查看", // 按钮名称
        material_id: item.id, // 素材ID
        material_name: item.title, // 素材标题
        material_file_size: item.size, // 素材文件大小
        material_format: item.ext, // 素材格式
        page_id: this.page_id, // 页面唯一标识
        page_url: this.page_url, // 页面链接
        page_name: "素材", // 页面名
        tab_name: "素材", // tab名称
      });
    },
    // 判断文件大小
    isFileSize(fileSizeKB, limitMB) {
      // 将 MB 转换为 KB 进行比较
      const limitKB = limitMB * 1024;
      return fileSizeKB > limitKB;
    },
    // 转发给客户
    async forwardToCustomer() {
      if (this.fileInfo.type === 1) {
        this.fileInfo.size = this.fileInfo.pictures.size;
        this.fileInfo.ext = this.fileInfo.pictures.ext;
        // 图片
        await wxSDK.shareToExternalContact(this.fileInfo, "");
      } else if (this.fileInfo.type === 2) {
        this.fileInfo.size = this.fileInfo.videos.size;
        this.fileInfo.ext = this.fileInfo.videos.ext;
        // 视频
        if (this.isFileSize(this.fileInfo.videos.size, 10)) {
          // 超出10MB
          await wxSDK.shareToLink({
            id: this.fileInfo.id,
            title: this.fileInfo.title,
            link: {
              title: this.fileInfo.title, // 分享标题
              imgUrl: this.fileInfo.videoCoverUrl, // 分享封面
              desc: "", // 分享描述
              url:
                window.location.origin +
                "/s/file?shareKey=" +
                this.fileInfo.forwardKey, // 分享H5预览页面
            },
          });
        } else {
          // 未超出10MB
          const res = await uploadMediaApi({
            appId: global.APP_CONFIG.appId,
            cosUrl: this.fileInfo.cosPath,
            tenantId: 120000,
            type: "video",
          });
          if (res.code === 0) {
            await wxSDK.shareToExternalContact(this.fileInfo, res.data.id);
          }
        }
      } else if (this.fileInfo.type === 3) {
        this.fileInfo.size = "";
        this.fileInfo.ext = "";
        // 图文
        await wxSDK.shareToLink({
          id: this.fileInfo.id,
          title: this.fileInfo.title,
          link: {
            title: this.fileInfo.title, // 分享标题
            desc: this.fileInfo.description, // 分享描述
            url:
              window.location.origin +
              "/s/file?shareKey=" +
              this.fileInfo.forwardKey +
              "&userId=" +
              this.userInfo.userId, // 分享H5预览页面
            imgUrl: this.fileInfo.imgUrl, // 分享封面
          },
        });
      } else {
        this.fileInfo.size = this.fileInfo.attachment.size;
        this.fileInfo.ext = this.fileInfo.attachment.ext;
        // 文件
        const ext = this.fileInfo.attachment.ext;
        if (ext === "mp3" || ext === "amr") {
          if (this.isFileSize(this.fileInfo.attachment.size, 2)) {
            // 超出2MB
            await wxSDK.shareToLink({
              id: this.fileInfo.id,
              title: this.fileInfo.title,
              link: {
                title: this.fileInfo.title, // 分享标题
                desc: "", // 分享描述
                url:
                  window.location.origin +
                  "/s/file?shareKey=" +
                  this.fileInfo.forwardKey, // 分享H5预览页面
                imgUrl: this.iconMap[ext] || this.iconMap.lj, // 分享封面（判断文件类型给到封面图）
              },
            });
          } else {
            // 未超出20MB
            const res = await uploadMediaApi({
              appId: global.APP_CONFIG.appId,
              cosUrl: this.fileInfo.cosPath,
              tenantId: 120000,
              type: "file",
            });
            if (res.code === 0) {
              await wxSDK.shareToExternalContact(this.fileInfo, res.data.id);
            }
          }
        } else if (ext === "pdf" && this.fileInfo.isWatermark === 1) {
          await wxSDK.shareToLink({
            id: this.fileInfo.id,
            title: this.fileInfo.title,
            link: {
              title: this.fileInfo.title, // 分享标题
              desc: "", // 分享描述
              url:
                window.location.origin +
                "/s/file?shareKey=" +
                this.fileInfo.forwardKey +
                "&name=" +
                encodeURIComponent(this.userInfo.name) +
                "&userId=" +
                this.userInfo.userId, // 分享H5预览页面
              imgUrl: this.iconMap[ext] || this.iconMap.lj, // 分享封面（判断文件类型给到封面图）
            },
          });
        } else {
          if (this.isFileSize(this.fileInfo.attachment.size, 20)) {
            // 超出20MB
            await wxSDK.shareToLink({
              id: this.fileInfo.id,
              title: this.fileInfo.title,
              link: {
                title: this.fileInfo.title, // 分享标题
                desc: "", // 分享描述
                url:
                  window.location.origin +
                  "/s/file?shareKey=" +
                  this.fileInfo.forwardKey, // 分享H5预览页面
                imgUrl: this.iconMap[ext] || this.iconMap.lj, // 分享封面（判断文件类型给到封面图）
              },
            });
          } else {
            // 未超出20MB
            const res = await uploadMediaApi({
              appId: global.APP_CONFIG.appId,
              cosUrl: this.fileInfo.cosPath,
              tenantId: 120000,
              type: "file",
            });
            if (res.code === 0) {
              await wxSDK.shareToExternalContact(this.fileInfo, res.data.id);
            }
          }
        }
      }
      // 埋点 素材转发给客户
      pageClickEvent({
        button_name: "素材转发给客户", // 按钮名称
        material_id: this.fileInfo.id, // 素材ID
        material_name: this.fileInfo.title, // 素材标题
        material_file_size: this.fileInfo.size, // 素材文件大小
        material_format: this.fileInfo.ext, // 素材格式
        page_id: this.page_id, // 页面唯一标识
        page_url: this.page_url, // 页面链接
        page_name: "素材工作台", // 页面名
        tab_name: "素材", // tab名称
      });
    },
    // 转发给同事
    async forwardToColleagues() {
      if (this.popupType === 1) {
        // 埋点 素材分组-转发给同事
        pageClickEvent({
          button_name: "素材分组-转发给同事", // 按钮名称
          folder_id: this.fileInfo.groupId, // 素材ID
          folder_name: this.fileInfo.groupName, // 素材标题
          page_id: this.page_id, // 页面唯一标识
          page_url: this.page_url, // 页面链接
          page_name: "素材", // 页面名
          tab_name: "素材", // tab名称
        });
        // 文件夹
        const link =
          window.location.origin +
          `/s/group/120000?ids=${this.fileInfo.groupId}&groupName=${this.fileInfo.groupName}&isGroupShare=1`; // 分享H5预览页面
        console.log(link);

        await wxSDK.shareAppMessage({
          title: this.fileInfo.groupName, // 分享标题
          desc: "", // 分享描述
          link: link, // 分享H5预览页面
          imgUrl:
            "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/iconMaterial/icon_lj.png", // 分享封面
        });
      } else {
        if (this.fileInfo.type === 1) {
          this.fileInfo.size = this.fileInfo.pictures.size;
          this.fileInfo.ext = this.fileInfo.pictures.ext;
          // 图片
          await wxSDK.shareAppMessage({
            title: this.fileInfo.title, // 分享标题
            desc: "", // 分享描述
            link: window.location.origin + "/s/file?id=" + this.fileInfo.id, // 分享H5预览页面
            imgUrl: this.fileInfo.cosPath, // 分享封面
          });
        } else if (this.fileInfo.type === 2) {
          this.fileInfo.size = this.fileInfo.videos.size;
          this.fileInfo.ext = this.fileInfo.videos.ext;
          // 视频
          await wxSDK.shareAppMessage({
            title: this.fileInfo.title, // 分享标题
            desc: "", // 分享描述
            link: window.location.origin + "/s/file?id=" + this.fileInfo.id, // 分享H5预览页面
            imgUrl: this.fileInfo.videoCoverUrl, // 分享封面
          });
        } else if (this.fileInfo.type === 3) {
          this.fileInfo.size = "";
          this.fileInfo.ext = "";
          // 图文
          await wxSDK.shareAppMessage({
            title: this.fileInfo.title, // 分享标题
            desc: this.fileInfo.description, // 分享描述
            link: window.location.origin + "/s/file?id=" + this.fileInfo.id, // 分享H5预览页面
            imgUrl: this.fileInfo.imgUrl, // 分享封面
          });
        } else {
          this.fileInfo.size = this.fileInfo.attachment.size;
          this.fileInfo.ext = this.fileInfo.attachment.ext;
          // 文件
          await wxSDK.shareAppMessage({
            title: this.fileInfo.title, // 分享标题
            desc: "", // 分享描述
            link: window.location.origin + "/s/file?id=" + this.fileInfo.id, // 分享H5预览页面
            imgUrl: this.iconMap[this.fileInfo.ext] || this.iconMap.lj, // 分享封面
          });
        }
        // 埋点 转发给同事
        pageClickEvent({
          button_name: "转发给同事", // 按钮名称
          material_id: this.fileInfo.id, // 素材ID
          material_name: this.fileInfo.title, // 素材标题
          material_file_size: this.fileInfo.size, // 素材文件大小
          material_format: this.fileInfo.ext, // 素材格式
          page_id: this.page_id, // 页面唯一标识
          page_url: this.page_url, // 页面链接
          page_name: "素材", // 页面名
          tab_name: "素材", // tab名称
        });
      }
    },
    // 复制链接
    async copyLink() {
      if (this.popupType === 1) {
        // 埋点 素材分组-复制链接
        pageClickEvent({
          button_name: "素材分组-复制链接", // 按钮名称
          folder_id: this.fileInfo.groupId, // 素材分组ID
          folder_name: this.fileInfo.groupName, // 素材分组标题
          page_id: this.page_id, // 页面唯一标识
          page_url: this.page_url, // 页面链接
          page_name: "素材", // 页面名
          tab_name: "素材", // tab名称
        });
        // 文件夹
        const link =
          window.location.origin +
          `/s/group/120000?shareKey=${this.fileInfo.shareKey}`; // 分享H5预览页面
        await navigator.clipboard.writeText(link);
      } else {
        if (this.fileInfo.type === 1) {
          // 图片
          this.fileInfo.size = this.fileInfo.pictures.size;
          this.fileInfo.format = this.fileInfo.pictures.ext;
          await navigator.clipboard.writeText(this.fileInfo.cosPath);
        } else if (this.fileInfo.type === 2) {
          // 视频
          this.fileInfo.size = this.fileInfo.videos.size;
          this.fileInfo.format = this.fileInfo.videos.ext;
          await navigator.clipboard.writeText(this.fileInfo.cosPath);
        } else if (this.fileInfo.type === 3) {
          // 图文
          this.fileInfo.size = "";
          this.fileInfo.format = "";
          const link =
            window.location.origin +
            "/s/file?shareKey=" +
            this.fileInfo.shareKey +
            "&name=" +
            this.userInfo.userId; // 分享H5预览页面
          await navigator.clipboard.writeText(link);
        } else {
          // 文件
          this.fileInfo.size = this.fileInfo.videos.size;
          this.fileInfo.format = this.fileInfo.videos.ext;
          const link =
            window.location.origin +
            "/s/file?shareKey=" +
            this.fileInfo.shareKey; // 分享H5预览页面
          await navigator.clipboard.writeText(link);
        }
        // 埋点 复制链接
        pageClickEvent({
          button_name: "复制链接", // 按钮名称
          material_id: this.fileInfo.id, // 素材ID
          material_name: this.fileInfo.title, // 素材标题
          material_file_size: this.fileInfo.size, // 素材文件大小
          material_format: this.fileInfo.ext, // 素材格式
          page_id: this.page_id, // 页面唯一标识
          page_url: this.page_url, // 页面链接
          page_name: "素材", // 页面名
          tab_name: "素材", // tab名称
        });
      }
      Toast("已复制链接，访问有效期为5日");
    },
    // 按转发量排序
    checkSort() {
      this.sort = this.sort ? "" : "forwardCount";
      this.fileList = [];
      this.pageIndex = 1;
      this.finished = false;
      this.getMaterial();
    },
    // 下载
    downloadFn(item) {
      if (item) {
        this.fileInfo = item;
      } else {
        this.show = false;
      }
      // 设置文件 key和文件名
      if (this.fileInfo.type === 1) {
        this.key = this.fileInfo.pictures.key;
        this.fileName = this.fileInfo.pictures.name;
        this.fileInfo.size = this.fileInfo.pictures.size;
        this.fileInfo.format = this.fileInfo.pictures.ext;
        this.showActionSheet = true;
        return;
      } else if (this.fileInfo.type === 2) {
        this.key = this.fileInfo.videos.key;
        this.fileName = this.fileInfo.videos.name;
        this.fileInfo.size = this.fileInfo.videos.size;
        this.fileInfo.format = this.fileInfo.videos.ext;
        this.cosDownloadFn();
      } else if (this.fileInfo.type === 4) {
        if (
          this.fileInfo.attachment.ext === "jpg" ||
          this.fileInfo.attachment.ext === "png"
        ) {
          this.showActionSheet = true;
          return;
        }
        this.key = this.fileInfo.attachment.key;
        this.fileName = this.fileInfo.attachment.name;
        this.fileInfo.size = this.fileInfo.attachment.size;
        this.fileInfo.format = this.fileInfo.attachment.ext;
        this.cosDownloadFn();
      }
    },
    // pdf预览下载
    async previewDownload(item) {
      if (item) {
        this.fileInfo = item;
      } else {
        this.show = false;
      }
      try {
        Toast.loading({
          message: "下载中...",
          forbidClick: true,
          duration: 0,
        });
        await this.$nextTick();

        const baseUrl = this.fileInfo.cosPath.split("?")[0];
        const decodedSign = decodeURIComponent(
          this.fileInfo.cosPath.split("sign=")[1]
        );

        const urlSafeBase64 = encodeURI(this.fileInfo.watermarkContent);

        const url =
          baseUrl +
          `?${decodedSign}` + // 签名参数
          `&ci-process=doc-preview&dstType=watermark&type=2` +
          `&text=${urlSafeBase64}` + // 水印内容（编码后）
          `&batch=1&degree=30&dissolve=30`; // 平铺+旋转+透明度

        console.log(url);

        const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = `${this.fileInfo.title}.pdf`;
        document.body.appendChild(a);
        a.click();

        setTimeout(() => {
          document.body.removeChild(a);
          URL.revokeObjectURL(blobUrl);
        }, 100);
      } catch (error) {
        console.error("生成PDF失败:", error);
      } finally {
        Toast.clear();
      }
    },
    // 获取话术标签
    async getTagGroupList() {
      const res = await tagGroupListApi({
        appId: 10001,
        catId: 100,
      });
      if (res.code === 0) {
        this.tagList = res.data;
      }
    },
    // 选择标签
    checkTag(item) {
      const ids = this.$route.query.ids.split(",").map(Number);
      if (this.tagIdList.includes(item.tagId)) {
        this.tagIdList = this.tagIdList.filter((item) => item !== item.tagId);
      } else {
        this.tagIdList = [...this.tagIdList, item.tagId];
      }
      if (ids.length === 1 && this.tagIdList.length === 0) {
        // 1级目录且没选择标签
        this.pageIndex = 1;
        this.fileList = [];
        this.finished = false;
        this.showGroup = true;
        return;
      }
      this.pageIndex = 1;
      this.fileList = [];
      this.finished = false;
      if (this.tagIdList.length === 0) {
        this.showGroup = true;
      } else {
        this.showGroup = false;
      }
      // 埋点 素材标签
      pageClickEvent({
        button_name: "素材标签", // 按钮名称
        tag_id: item.tagId, // 标签id
        tag_name: item.tagName, // 标签id
        page_id: this.page_id, // 页面唯一标识
        page_url: this.page_url, // 页面链接
        page_name: "素材", // 页面名
        tab_name: "素材", // tab名称
      });
      this.getMaterial();
    },
    // 选择图片质量
    selectSheet(action, index) {
      switch (index) {
        case 0:
          this.imgQuality = "imageMogr2/rquality/100";
          break;
        case 1:
          this.imgQuality = "imageMogr2/rquality/80";
          break;
        case 2:
          this.imgQuality = "imageMogr2/rquality/60";
          break;
      }
      this.cosDownloadFn();
    },
    // cos下载
    cosDownloadFn() {
      // 埋点 素材下载
      pageClickEvent({
        button_name: "素材下载", // 按钮名称
        material_id: this.fileInfo.id, // 素材ID
        material_name: this.fileInfo.title, // 素材标题
        material_file_size: this.fileInfo.size, // 素材文件大小
        material_format: this.fileInfo.format, // 素材格式
        page_id: this.page_id, // 页面唯一标识
        page_url: this.page_url, // 页面链接
        page_name: "素材", // 页面名
        tab_name: "素材", // tab名称
      });
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      if (!userInfo) {
        // 图片
        if (
          this.fileInfo.type === 1 ||
          (this.fileInfo.type === 4 &&
            (this.fileInfo.attachment.ext === "jpg" ||
              this.fileInfo.attachment.ext === "png"))
        ) {
          this.fileInfo.cosPath += `&${this.imgQuality}`;
        }
        const downloadUrl =
          this.fileInfo.cosPath +
          (this.fileInfo.cosPath.indexOf("?") > -1 ? "&" : "?") +
          "response-content-disposition=attachment"; // 补充强制下载的参数
        console.log("downloadUrl", downloadUrl);

        // 网页环境
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = this.fileName;
        document.body.appendChild(link);
        link.click();
        this.imgQuality = "";
        document.body.removeChild(link);
        return;
      }
      this.toast = Toast.loading({
        duration: 0,
        message: "下载中...（0%）",
        forbidClick: true,
      });
      const cosFn = cosObj(this.cosKey);
      cosFn.getObject(
        {
          Bucket: this.cosKey.bucket, // 填入您自己的存储桶，必须字段
          Region: this.cosKey.region, // 存储桶所在地域，例如 ap-beijing，必须字段
          Key: decodeURIComponent(this.key), // 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段
          onProgress: (progressData) => {
            this.toast.message = `下载中...\n（${progressData.percent *
              100}%）`;
            if (progressData.percent === 1) {
              this.toast.message = `下载完成`;
              setTimeout(() => {
                Toast.clear();
              }, 1000);
            }
          },
        },
        async (err, data) => {
          if (err) return console.log(err);
          cosFn.getObjectUrl(
            {
              Bucket: this.cosKey.bucket,
              Region: this.cosKey.region,
              Key: decodeURIComponent(this.key),
            },
            (err, data) => {
              if (err) return console.log(err);
              // 图片
              if (
                this.fileInfo.type === 1 ||
                (this.fileInfo.type === 4 &&
                  (this.fileInfo.attachment.ext === "jpg" ||
                    this.fileInfo.attachment.ext === "png"))
              ) {
                data.Url += `&${this.imgQuality}`;
              }
              const downloadUrl =
                data.Url +
                (data.Url.indexOf("?") > -1 ? "&" : "?") +
                "response-content-disposition=attachment"; // 补充强制下载的参数
              console.log("downloadUrl", downloadUrl);

              const link = document.createElement("a");
              link.href = downloadUrl;
              link.download = this.fileName;
              document.body.appendChild(link);
              link.click();
              this.imgQuality = "";
              document.body.removeChild(link);
            }
          );
          // 新增下载记录
          await addDownloadRecordApi({
            sourceId: this.fileInfo.id,
            sourceName: this.fileInfo.title,
            sourceType: 1,
          });
        }
      );
    },
    // 重置标签
    resetTags() {
      const ids = this.$route.query.ids.split(",").map(Number);
      if (ids.length === 1) {
        // 首页
        this.tagIdList = [];
        this.pageIndex = 1;
        this.fileList = [];
        this.finished = false;
      } else {
        this.tagIdList = [];
        this.pageIndex = 1;
        this.fileList = [];
        this.finished = false;
        this.getMaterial();
      }
      this.showGroup = true;
    },
    // 更新订阅
    updateFn() {
      this.showOverlay = false;
      this.$router.push("/message");
    },
    // 关闭预览图片
    closeImgOverlay() {
      this.showPreviewImgOverlay = false;
      this.previewImgRef.close();
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.workMaterial {
  position: relative;
  width: 100%;
  height: 100vh;
  .basic-materials {
    position: relative;
    width: 100%;
    height: 100%;
    padding-bottom: calc(constant(safe-area-inset-bottom) + 50px);
    padding-bottom: calc(env(safe-area-inset-bottom) + 50px);
    .search-box {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 40px;
      padding: 4px 12px;
      background-color: #fff;
      z-index: 9;
      .left {
        position: relative;
        flex: 1;
        margin-right: 12px;
        ::v-deep .van-search {
          width: 100%;
          height: 32px;
          background: #f8f8f8;
          border-radius: 30px;
          .van-field__left-icon {
            img {
              width: 20px;
              height: 20px;
            }
          }
          .van-search__content {
            padding-left: 0;
          }
          .van-field {
            display: flex;
            align-items: center;
            line-height: 1;
            .van-field__control:disabled {
              -webkit-text-fill-color: #323233;
            }
            .van-field__control::placeholder {
              -webkit-text-fill-color: #c8c9cc;
            }
          }
        }
        .search-region {
          position: absolute;
          top: 0;
          left: 12px;
          width: 100%;
          height: 32px;
        }
      }
    }
    .popup-tags {
      position: absolute;
      top: 80px;
      left: 0;
      width: 100%;
      max-height: 400px;
      z-index: 9;
      background-color: #fff;
      padding: 5px 20px 15px;
      border-radius: 0 0 10px 10px;
      overflow-y: hidden;
      .tag-item {
        &:last-child {
          .tag-cont {
            margin-bottom: 0;
          }
        }
        .tag-cont {
          margin-bottom: 12px;
        }
      }
      .tags-title {
        font-weight: 500;
        font-size: 13px;
        color: #333333;
        margin-bottom: 10px;
        cursor: pointer;
      }
      .tags-list {
        display: flex;
        flex-wrap: wrap;
        .tags-item {
          height: 24px;
          background: #f7f7f7;
          border-radius: 2px 2px 2px 2px;
          padding: 5px 10px;
          margin-right: 10px;
          margin-bottom: 8px;
          font-size: 12px;
          color: #666666;
          text-align: center;
          border: 1px solid #fff;
          cursor: pointer;
        }
        .act {
          border: 1px solid #4d4d4d;
          color: #333333;
        }
      }
      ::v-deep .van-tabs {
        height: 380px;
        overflow-y: hidden;
        .van-tabs__wrap {
          width: 64px;
          height: 32px;
        }
        .van-tabs__content {
          height: 330px;
          padding-top: 10px;
          overflow-y: auto;
        }
      }
      .reset {
        position: absolute;
        top: 12px;
        right: 20px;
        font-size: 14px;
        color: #007ad3;
        cursor: pointer;
      }
    }
    .crumbs {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 40px;
      background-color: #fff;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      padding: 12px 10px;
      z-index: 9;
      .xgang {
        height: 12px;
        padding: 0 8px;
      }
      .crumbs-box {
        flex: 1;
        display: flex;
        align-items: center;
        overflow-x: auto;
        padding-right: 10px;
      }
      .crumbs-list {
        display: flex;
        align-items: center;
      }
      .crumbs-item {
        cursor: pointer;
        white-space: nowrap;
      }
      .update {
        flex-shrink: 0;
        width: 80px;
        padding: 5px 0;
        border: 1px solid #000;
        border-radius: 15px;
        background-color: #fff;
        text-align: center;
        cursor: pointer;
      }
    }
    .cont {
      height: calc(100% - 80px);
      padding: 10px 12px;
      overflow-y: auto;
      .list-box {
        background-color: #fff;
        padding: 15px;
        margin-bottom: 10px;
        .list-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          color: #999999;
          margin-bottom: 8px;
          .sort {
            display: flex;
            align-items: center;
            height: 22px;
            border-radius: 302px;
            border: 1px solid #f1f1f1;
            font-size: 10px;
            color: #666666;
            line-height: 18px;
            padding: 2px 10px;
            .icon-sort {
              width: 10px;
              height: 10px;
              margin-right: 4px;
            }
          }
          .forwardCount {
            border: 1px solid #333;
            color: #333;
          }
        }
        .folder {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          height: 48px;
          border-radius: 6px 6px 6px 6px;
          border: 1px solid #f5f5f5;
          padding: 8px 15px 8px 12px;
          font-size: 14px;
          color: #3d3d3d;
          margin-bottom: 6px;
          cursor: pointer;
          &:last-child {
            margin-bottom: 0;
          }
          .folder-left {
            display: flex;
            align-items: center;
          }
          .folder-img {
            width: 32px;
            height: 32px;
            margin-right: 8px;
          }
          .more-img {
            width: 16px;
            height: 16px;
          }
        }
        .files {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          height: 70px;
          border-radius: 10px 10px 10px 10px;
          border: 1px solid #f5f5f5;
          padding: 15px 15px 15px 12px;
          margin-bottom: 6px;
          cursor: pointer;
          &:last-child {
            margin-bottom: 0;
          }
          .file-left {
            display: flex;
            align-items: center;
            width: 85%;
            overflow: hidden;
            .file-info {
              width: calc(100% - 50px);
              .file-i-title {
                font-weight: 600;
                font-size: 13px;
                color: #3d3d3d;
                margin-bottom: 8px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .file-i-time {
                font-size: 12px;
                color: #999999;
              }
            }
          }
          .file-img {
            flex-shrink: 0;
            width: 40px;
            height: 40px;
            margin-right: 10px;
          }
          .download-img {
            width: 16px;
            height: 16px;
            margin-right: 9px;
            cursor: pointer;
          }
          .more-img {
            width: 16px;
            height: 16px;
            cursor: pointer;
          }
          .zb {
            position: absolute;
            right: 0;
            top: 0;
            width: 36px;
            height: 18px;
          }
        }
      }
    }
    .isShare {
      height: calc(100% - 40px);
    }
    .no-more {
      color: #969799;
      font-size: 14px;
      line-height: 50px;
      text-align: center;
    }
  }
  .message-subscription {
    width: 100%;
    height: 100%;
    padding-bottom: calc(constant(safe-area-inset-bottom) + 50px);
    padding-bottom: calc(env(safe-area-inset-bottom) + 50px);
    .tips {
      padding: 10px 15px;
      font-size: 12px;
      color: #999999;
    }
    .grouping {
      height: calc(100% - 56px);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background-color: #fff;
      padding-bottom: 15px;
      .grouping-list {
        padding: 0 15px;
        margin-bottom: 20px;
        overflow-y: auto;
      }
      .grouping-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px;
        font-size: 15px;
        color: #333333;
        border-bottom: 1px solid #f3f3f3;
      }
      .title {
        font-weight: 500;
      }
      .btn-box {
        width: 100%;
        padding: 0 15px;
        .btn {
          width: 100%;
          height: 42px;
          background: #f26147;
          border-radius: 8px 8px 8px 8px;
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
          text-align: center;
          line-height: 42px;
          cursor: pointer;
        }
      }
    }
  }
  .more-popup {
    padding: 20px;
    .more-title {
      display: flex;
      align-items: center;
      margin-bottom: 32px;
      img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }
      .txt1 {
        width: 200px;
        font-weight: 600;
        font-size: 13px;
        color: #3d3d3d;
        margin-bottom: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .txt2 {
        font-size: 12px;
        color: #999999;
      }
      .txt3 {
        font-size: 12px;
        color: #999999;
        margin-top: 5px;
      }
    }
    .more-list {
      display: flex;
      padding: 0 12px;
      .popup-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 12px;
        color: #3d3d3d;
        cursor: pointer;
        margin-right: 30px;
        &:last-child {
          margin-right: 0;
        }
        img {
          width: 48px;
          height: 48px;
          margin-bottom: 8px;
        }
      }
    }
  }
  .video-popup {
    display: flex;
    width: 100%;
    padding: 0;
    .video {
      width: 100%;
      max-height: 500px;
    }
  }
  .audio-popup {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 0;
    background-color: transparent;
  }
  .imgtxt-popup {
    .popup-main {
      height: 100%;
      overflow: hidden;
      .imgtxt-title {
        height: 30px;
        font-weight: 500;
        font-size: 16px;
        color: #3d3d3d;
        padding: 20px;
        margin-bottom: 10px;
      }
      .imgtxt-cont {
        height: calc(100% - 50px);
        font-size: 14px;
        color: #666666;
        line-height: 18px;
        overflow-y: auto;
        padding: 0 20px;
        img {
          width: 100%;
        }
        ::v-deep p {
          word-break: break-all;
        }
      }
    }
  }
  ::v-deep .van-tabbar {
    box-sizing: content-box;
  }
}
.permission {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 120px;
  .error {
    width: 240px;
    height: 191px;
    margin-bottom: 24px;
  }
  .txt {
    font-size: 14px;
    color: #333333;
    line-height: 24px;
    text-align: center;
  }
}
.img-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
}
</style>
